




























































































import { Component } from 'vue-property-decorator'
import ViewBase from '@/util/ViewBase'
import AccountForm from './../accountForm.vue'
import conFirm from './../confirm.vue'
import { post, get } from '@/fn/ajax'
import { fetchStudentList, getAllStudentByClass } from './student.api'
import { Tooltip, Modal, message } from 'ant-design-vue'
import XLSX from 'xlsx'
import Excel from './../excel/excel.js'
import StudentCreate from './studentCreate.vue'
import StudentEdit from './studentEdit.vue'
import StudentImport from './studentImport.vue'
import StudentUploadInfo from './studentUploadInfo.vue'
import StudentRemove from './studentRemove.vue'
import TitleBack from '@/components/titleBack/titleBack.vue'
@Component({
  components: {
    AccountForm,
    conFirm,
    StudentCreate,
    StudentImport,
    StudentUploadInfo,
    StudentEdit,
    StudentRemove,
    TitleBack
  }
})
export default class StudentList extends ViewBase {
  lang = {}

  doc: any = null

  className: string = ''

  classId: any = null

  columns: any = null

  pagination: any = null

  loading: boolean = false

  list: any = []

  deleteId: string = ''

  submiting: boolean = false

  createConfirm: boolean = false

  showLoadInfo: boolean = false

  createModal: boolean = false

  selectExcel: boolean = false

  editModal: boolean = false

  removeModal: boolean = false

  uploadData: any = null

  editStudent: any = null

  get i18n() {
    const value = this.$t('login')
    return value as any
  }

  handleTableChange(pagination: any) {
    // console.log(pagination)
    const pager: any = { ...this.pagination }
    pager.current = pagination.current
    this.pagination = pager
    this.fetch({
      page: pagination.current
    })
  }

  cancelCreate() {
    this.createConfirm = false
  }

  async postDel(data: any) {
    this.submiting = true
    const res = await post('/api/UserRes/del', data)
    return res
  }

  async deleteResource() {
    const pdata: any = {
      rid: this.deleteId
    }
    try {
      const res = await this.postDel(pdata)
      this.submiting = false
      this.$message.success(res.msg)
      this.fetch({
        page: this.pagination.current || 1,
        phase: 0,
        subject: 0
      })
    } catch (ex) {
      this.handleError(ex)
    }
  }
  cancelMod() {
    this.createModal = false
    this.selectExcel = false
    this.showLoadInfo = false
    this.editModal = false
    this.removeModal = false
  }
  toEdit(item: any) {
    this.editModal = true
    this.editStudent = item
  }

  removeClick(item: any) {
    this.removeModal = true
    this.editStudent = item
  }

  async fetch(params: any = {}) {
    params.class_id = this.classId
    this.loading = true
    try {
      const res = await fetchStudentList(params)
      const data = res.data
      this.loading = false
      const pagination: any = { ...this.pagination }
      pagination.total = data.total
      this.loading = false
      this.list = data.list
      this.pagination = pagination
    } catch (ex) {
      this.handleError(ex)
    }
  }

  toAdd() {
    this.createModal = true
  }

  clickUploadExcel() {
    this.selectExcel = true
  }

  createClass() {}
  setColums() {
    const lang: any = this.lang
    this.columns = [
      {
        title: this.i18n.vStudentList.stuIndex,
        dataIndex: 'number',
        width: '100px'
      },
      {
        title: this.i18n.vStudentList.stuName2,
        dataIndex: 'stu_name'
      },
      {
        title: this.i18n.vStudentList.stuNumText,
        dataIndex: 'stu_number',
        className: 'stu_number',
        width: '300px'
      },
      {
        title: lang.operation,
        dataIndex: 'operation',
        width: '280px',
        className: 'texcenter operation',
        scopedSlots: { customRender: 'operation' }
      }
    ]
    this.fetch()
  }

  showLoading(show: boolean) {
    if (show) {
      this.submiting = true
    } else {
      this.submiting = false
    }
  }

  loadedExcel(data: any) {
    this.uploadData = data
    this.showLoadInfo = true
    this.selectExcel = false
    this.submiting = false
  }
  setExportExcelData(data: any) {
    const datas: any = []
    data.forEach((item: any) => {
      const stu: any = {}
      stu.stu_name = item.stu_name
      stu.stu_number = item.stu_number
      datas.push(stu)
    })
    return datas
  }

  async exportToExcel() {
    const params: any = {}
    params.class_id = this.classId
    try {
      const res = await getAllStudentByClass(params)
      const fields: any = {
        stu_name: this.i18n.vStudentList.stuName,
        stu_number: this.i18n.vStudentList.stuNumber
      }
      const exportData = this.setExportExcelData(res.data)
      exportData.forEach((item: any) => {
        fields['_' + item.key] = item.value // 动态生成的头
      })
      // fields.totalCommission = '奖励总数'
      // 此处有vue大坑，不能直接使用xlsx(this.getComputedData),必须先转一下
      const data = JSON.parse(JSON.stringify(exportData))
      const excel: any = Excel
      excel(data, fields, this.className)
    } catch (ex) {
      this.handleError(ex)
    }
  }

  refreshList() {
    this.cancelMod()
    this.fetch({
      page: this.pagination.current || 1
    })
  }

  created() {
    this.classId = parseInt(this.$route.params.id, 10)
    this.className = this.$route.params.class
    this.doc = window.document
    this.lang = this.i18n.resource
    this.setColums()
  }
}
